import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("token");
  const user = localStorage.getItem("user");

  const [hasShownToast, setHasShownToast] = useState(false);
  const params = useParams();
  const orderId = params?.orderId;
  if (orderId) localStorage.setItem("orderId", orderId);

  useEffect(() => {
    if (isLoggedIn === null && !hasShownToast && orderId) {
      const intended = `/orders/${orderId}`;

      try {
        localStorage.setItem("returnToCart", intended);
      } catch {}
      navigate(`/signup-prompt?redirect=${encodeURIComponent(intended)}`, {
        replace: true,
      });
      setHasShownToast(true);
    } else if ((isLoggedIn === null || !user) && !hasShownToast) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      navigate("/", { replace: true });
      setHasShownToast(true);
    }
    // Removed redirect for logged-in users visiting '/'
    // Previously: if (isLoggedIn && window.location.pathname === "/") navigate("/overview")
  }, [isLoggedIn, navigate, hasShownToast]);

  return <>{children}</>;
};

export default AuthGuard;
